import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmButtons',
  props: {
  disabled: Boolean,
  disabledOk: Boolean,
  okLabel: {
    type: String, default: ''
  },
  cancelLabel: {
    type: String, default: ''
  },
  buttonWidth: {
    type: String, default: 'auto'
  },
  hideCancel: Boolean
},
  setup(__props) {





return { __sfc: true, }
}

})